import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EMBED_ASSETS_HOST } from '../constants';
import { AccountRow } from '../types';

type AccountLogoProps = {
  account: AccountRow;
};

function getLogoSrc(account: AccountRow): string | null {
  if (account.Type === 'Bank Account') {
    return account.BankId ? `${EMBED_ASSETS_HOST}/images/logos-banks/${account.BankId}.svg` : null;
  }

  return account.CreditCardBrand ? `${EMBED_ASSETS_HOST}/images/${account.CreditCardBrand}.png` : null;
}

// Each logo owns its own failed flag. Hoisting it into the table keyed by row position breaks on a
// sort or a delete: the suppression follows the slot, not the image.
export default function AccountLogo({ account }: AccountLogoProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.PaymentMethodsTable' });
  const [hasFailedLoading, setHasFailedLoading] = useState(false);
  const src = getLogoSrc(account);

  if (!src || hasFailedLoading) return null;

  const alt =
    account.Type === 'Bank Account'
      ? t('bankLogoAlt', { defaultValue: 'bank logo' })
      : t('cardLogoAlt', { defaultValue: 'card logo' });

  return <img alt={alt} src={src} onError={() => setHasFailedLoading(true)} />;
}
